import logo from 'HiveClient/images/logo.png';
import icon from 'HiveClient/images/logo-icon.png';
import logoFooter from 'HiveClient/images/logo-footer.png';
import favicon from 'HiveClient/images/favicon.png';
import faviconNotification from 'HiveClient/images/favicon-notification.png';
import { IClientAssets } from '@config/IClientAssets';

export const ClientAssets: IClientAssets = {
  logo,
  icon,
  logoFooter,
  favicon,
  faviconNotification,
};
